import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row nowrap justify-content-between mb-3 heading" }
const _hoisted_2 = { class: "caption" }
const _hoisted_3 = { class: "my-4" }

import {
	reactive,
	onMounted,
	onBeforeUnmount,
	ref,
} from "vue"

import { onKeyStroke } from "@vueuse/core"

// common components
import TextInput from "@/components/LoginRegister/common/inputs/Text/v1/Text.vue"
import Button from "@/components/LoginRegister/common/Button/v1/Button.vue"

// logic
import resetPassword from "@/logic/contact/resetPassword"

// composables
import useLoading from "@/composables/useLoading"

// state
import email from "@/state/email"
import loggedInUser from "@/state/loggedInUser"

// Translations
import { useI18n } from 'vue-i18n'
import {getQueryParams} from "@/utils"

interface Emits {
	(e: "emailSent"): void
}




export default /*@__PURE__*/_defineComponent({
  __name: 'ResetForm',
  emits: ["emailSent"],
  setup(__props, { emit: __emit }) {

const {t} = useI18n()

// utils
const emailwrapper = ref()

// query params
const queryParams = getQueryParams()

// emit
const emit = __emit

// handlers
const handleButtonClick = async () => {
	const { startLoadingThis, stopLoadingThis } = useLoading()
	startLoadingThis()
	await resetPassword()
	emit("emailSent")
	stopLoadingThis()
}

onMounted(() => {
	// onKeyStroke
	const stop = onKeyStroke("Enter", () => {
		if (!email.value) return
		handleButtonClick()
	})
	onBeforeUnmount(() => stop())

	emailwrapper.value.querySelector("input").focus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.user_info_forgot_password")), 1)
    ]),
    _createElementVNode("div", {
      ref_key: "emailwrapper",
      ref: emailwrapper,
      class: "mb-3"
    }, [
      _createVNode(TextInput, {
        disabled: true,
        value: _unref(email),
        placeholder: _unref(t)('loginRegister.contacts_email'),
        type: 'email'
      }, null, 8, ["value", "placeholder"])
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.user_info_enter_email")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Button, {
        disabled: !_unref(email),
        onButtonClick: _cache[0] || (_cache[0] = (e) => handleButtonClick(e))
      }, {
        text: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("loginRegister.send")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})